import React, { useState, useCallback } from 'react'
import { Grid, Menu, MenuItem, withStyles, ListItemIcon, ListItemText } from '@material-ui/core'
import useRouter from 'utils/useRouter'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import EditIcon from '@material-ui/icons/Edit'
import AddCommentIcon from '@material-ui/icons/AddComment'
import AddIcon from '@material-ui/icons/Add'

import { CustomButton } from 'components'
import { useStyles } from './MenuAcoes.styles'

const StyledMenu = withStyles((theme) => ({
  paper: {
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: theme.shadows[4],
    borderRadius: '16px',
    minWidth: '240px',
    padding: '8px',
    backgroundColor: theme.palette.background.paper,
  },
}))((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))

const StyledMenuItem = withStyles((theme) => ({
  root: {
    padding: '10px 16px',
    borderRadius: '10px',
    margin: '4px 0',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: theme.palette.action.hover || 'rgba(0, 0, 0, 0.04)',
      transform: 'translateX(4px)',
    },
    '& .MuiListItemIcon-root': {
      minWidth: '44px',
      color: theme.palette.primary.main,
    },
    '& .MuiListItemText-primary': {
      fontWeight: 600,
      fontSize: '0.875rem',
      color: theme.palette.text.primary,
    },
  },
}))(MenuItem)

export const MenuAcoes = (props) => {
  const { idSolicitacaoExame } = props
  const classes = useStyles()
  const router = useRouter()
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClickBotaoAcoes = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleMenuBotaoAcoes = (to) => {
    router.history.push(to)
    handleClose()
  }

  const handleClickAdicionarInformacao = useCallback(() => {
    router.history.push(`/solicitacaoExame/adicionarInformacao/${idSolicitacaoExame}`)
    handleClose()
  }, [router, idSolicitacaoExame])

  return (
    <Grid alignItems="center" justifyContent="flex-end" container spacing={1} className={classes.root}>
      <Grid item>
        <CustomButton
          aria-controls="customized-menu"
          aria-haspopup="true"
          onClick={handleClickBotaoAcoes}
          endIcon={<ArrowDropDownIcon />}
          colorType="primary"
        >
          Ações
        </CustomButton>
        <StyledMenu id="customized-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
          <StyledMenuItem onClick={() => handleMenuBotaoAcoes(`/casos/caso/solicitacao/editar/${idSolicitacaoExame}`)}>
            <ListItemIcon>
              <EditIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Editar Solicitação de Exame" />
          </StyledMenuItem>
          <StyledMenuItem onClick={() => handleMenuBotaoAcoes(`/casos/caso/solicitacao/adicionarexame/${idSolicitacaoExame}`)}>
            <ListItemIcon>
              <AddIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Adicionar exame solicitado" />
          </StyledMenuItem>
          <StyledMenuItem onClick={handleClickAdicionarInformacao}>
            <ListItemIcon>
              <AddCommentIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Adicionar Informação" />
          </StyledMenuItem>
        </StyledMenu>
      </Grid>
    </Grid>
  )
}
